import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/PaginateClinicalSites';
import {
    useGetClinicalDirectorsQuery,
    useDeleteClinicalDirectorMutation,
    useCreateClinicalDirectorMutation,
} from '../../slices/clinicalDirectorsApiSlice';

import { toast } from 'react-toastify';

const ClinicalDirectorListScreen = () => {
    const { pageNumber } = useParams();

    const { data, isLoading, error, refetch } = useGetClinicalDirectorsQuery({
        pageNumber,
    });

    const [deleteClinicalDirector, { isLoading: loadingDelete }] =
        useDeleteClinicalDirectorMutation();

    const deleteHandler = async (id) => {
        if (window.confirm(`Are you sure  ${id}`)) {
            try {
                await deleteClinicalDirector(id);
                refetch();
            } catch (err) {
                toast.error(err?.data?.message || err.error);
            }
        }
    };

    const [createClinicalDirector, { isLoading: loadingCreate }] =
        useCreateClinicalDirectorMutation();

    const createClinicalDirectorHandler = async () => {
        if (window.confirm('Are you sure you want to create a new Clinical Director?')) {
            try {
                await createClinicalDirector();
                refetch();
            } catch (err) {
                toast.error(err?.data?.message || err.error);
            }
        }
    };

    return (
        <>
            <Row className='align-items-center'>
                <Col>
                    <h1>Clinical Directors</h1>
                </Col>
                <Col className='text-end'>
                    <Button className='my-3' onClick={createClinicalDirectorHandler}>
                        <FaPlus /> Create A Clinical Director
                    </Button>
                </Col>
            </Row>

            {loadingCreate && <Loader />}
            {loadingDelete && <Loader />}
            {isLoading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error.data.message}</Message>
            ) : (
                <>
                    <Table striped bordered hover responsive className='table-sm'>
                        <thead>
                            <tr>

                                <th>Clinical Director Name</th>
                                <th> Description - Comments</th>
                                <th>Active Y or N</th>
                                <th>Directorate</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.clinicalDirectors.map((clinicaldirector) => (
                                <tr key={clinicaldirector._id}>

                                    <td>{clinicaldirector.clinicalDirectorName}</td>
                                    <td>{clinicaldirector.description}</td>
                                    <td>{clinicaldirector.activeYorN}</td>
                                    <td>{clinicaldirector.directorate}</td>

                                    <td>
                                        <LinkContainer to={`/admin/clinicaldirector/${clinicaldirector._id}/edit`}>
                                            <Button variant='outline-info' className='btn-sm mx-2'>
                                                <FaEdit /> Edit Item
                                            </Button>
                                        </LinkContainer>

                                        <Button
                                            variant='warning'
                                            className='btn-sm'
                                            onClick={() => deleteHandler(clinicaldirector._id)}
                                        >
                                            <FaTrash className='text-end' style={{ color: 'white' }} /> Delete
                                        </Button>

                                    </td>

                                    {/*
                  

                                    <td>
                                        <LinkContainer to={`/admin/clinicalSite/${clinicalSite._id}/edit`}>
                                            <Button variant='light' className='btn-sm mx-2'>
                                                <FaEdit />
                                            </Button>
                                        </LinkContainer>
                                        <Button
                                            variant='danger'
                                            className='btn-sm'
                                            onClick={() => deleteHandler(clinicalSite._id)}
                                        >
                                            <FaTrash style={{ color: 'white' }} />
                                        </Button>
                                    </td>

                            */}

                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Paginate pages={data.pages} page={data.page} isAdmin={true} />
                </>
            )}
        </>
    );
};

export default ClinicalDirectorListScreen;
